import type { UseStorageOptions } from './createStorage';
import { createStorage, readValue } from './createStorage';

/* 
  code from:
  https://github.com/mantinedev/mantine/blob/master/packages/%40mantine/hooks/src/use-local-storage/use-local-storage.ts
*/

export function useLocalStorage<T = string>(props: UseStorageOptions<T>) {
  return createStorage<T>('localStorage')(props);
}

export const readLocalStorageValue = readValue('localStorage');
